<template>
  <b-table
    :data="tableData"
    :columns="columns"
  />
</template>
<script>
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
export default {
  name: 'SuggestedTradeArea',
  components: { /* Subcomponents */ },
  props: ['trades'],
  data() {
    return {
      columns: [
        { 'field': 'symbol', 'label': 'Symbol', 'sortable': true },
        { 'field': 'name', 'label': 'Name', 'sortable': true },
        { 'field': 'market_value', 'label': 'Market Value', 'sortable': true },
        { 'field': 'change', 'label': 'Change', 'sortable': true },
        { 'field': 'new_value', 'label': 'New Value', 'sortable': true },
      ],
    };
  },
  computed: {
    ...mapStores(useCheckupStore),
    tableData() {
      const trades = this.trades;
      if (!trades) return [];
      const formattedTrades = trades.map(trade => {
        const row = { ...trade };
        row.market_value = '$' + row.market_value.toLocaleString();
        row.change = '$' + row.change.toLocaleString();
        row.new_value = '$' + row.new_value.toLocaleString();
        return row;
      }).filter(trade => {
        return (trade.market_value != '$0' || trade.change != '$0' || trade.new_value != '$0');
      });
      return formattedTrades;
    },
  },
};
</script>
<style>
</style>
